import styled from 'styled-components';
import { useSectionSpacingContext } from '../providers/SectionSpacingProvider.js';
import '../ui/Div/index.js';
import { BackgroundContainer } from './BackgroundContainer.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../ui/Div/Div.js';
function SectionComponentLayout({
  children,
  hasSpacingTop = false,
  hasSpacingHorizontal,
  hasNonDefaultBackgroundSpacingVertical,
  hasNonDefaultBackgroundSpacingTop,
  hasSpacingVertical,
  background = 'background',
  as = 'section',
  fullViewportWidth,
  flexDirection = 'column',
  height,
  anchor
}) {
  const _useSectionSpacingCon = useSectionSpacingContext(),
    horizontalSpacing = _useSectionSpacingCon.horizontalSpacing,
    spacingVerticalAround = _useSectionSpacingCon.spacingVerticalAround,
    spacingBetweenSections = _useSectionSpacingCon.spacingBetweenSections,
    anchorsPosition = _useSectionSpacingCon.anchorsPosition;
  const nonDefaultBackground = background !== 'transparent' && background !== 'background';
  return /*#__PURE__*/jsxs(SpacingContainer, {
    as: as,
    spacingTop: hasSpacingTop ? spacingBetweenSections : undefined,
    $nonDefaultBackground: nonDefaultBackground,
    className: nonDefaultBackground ? NON_DEFAULT_BACKGROUND_CLASS : undefined,
    children: [anchor && /*#__PURE__*/jsx(Div, {
      as: "span",
      id: anchor,
      css: {
        display: 'block',
        position: 'relative',
        top: anchorsPosition,
        visibility: 'hidden'
      }
    }), /*#__PURE__*/jsx(BackgroundContainer, {
      background: background,
      fullViewportWidth: fullViewportWidth,
      spacingHorizontal: hasSpacingHorizontal ? horizontalSpacing : undefined,
      spacingTop: hasNonDefaultBackgroundSpacingTop && nonDefaultBackground ? spacingVerticalAround : undefined,
      spacingVertical: hasSpacingVertical || hasNonDefaultBackgroundSpacingVertical && nonDefaultBackground ? spacingVerticalAround : undefined,
      flexDirection: flexDirection,
      width: "100%",
      height: height,
      children: children
    })]
  });
}
const NON_DEFAULT_BACKGROUND_CLASS = 'non-default-background';
const SpacingContainer = styled(Div)`
  flex-direction: column;
  width: 100%;
  max-width: 100vw;

  ${({
  $nonDefaultBackground
}) => $nonDefaultBackground &&
// If next sibling also has non default background, then the sections should not have spacing between.
`
    & + .${NON_DEFAULT_BACKGROUND_CLASS} {
      padding-top: 0 !important;
    }
    `}
`;
export { SectionComponentLayout };
//# sourceMappingURL=SectionComponentLayout.js.map
